// extracted by mini-css-extract-plugin
export var bold = "_si-0";